<template>
  <div>
    <van-loading size="9.8vw" vertical v-if="loading" class="loading-container">加载中...</van-loading>
    <div v-if="!loading">
      <plyr-player v-if="Video" :poster="Video?.Cover" :key="componentKey"></plyr-player>
      <play-list v-if="Video?.Count > 1" :count="Video?.Count"/>
      <div class="videoTabs" v-if="Video && upper">
        <van-tabs v-model:active="active">
          <van-tab title="简介">
            <div class="videoInfo">
              <up-info :upName="upper.Name" upFans="2058 粉丝" upVideos="39"/>
              <div class="videoTitle">
                <h1 class="title-text">{{ Video.Title }}</h1>
              </div>
            </div>
            <date-page/>
            <share like="4.7万" start="1.3万" share="2687" :vid="this.vid"/>
            <relate-videos :vid="this.vid" :slug="this.Category.Slug"/>
          </van-tab>
          <van-tab title="评论">
            <comment-page></comment-page>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>


<script>
import { defineComponent } from 'vue';
import PlyrPlayer from '@/components/viedo/PlyrPlayer.vue'; // 根据实际路径修改
import UpInfo from "@/components/archive/UpInfo";
import Share from "@/components/archive/Share";
import DatePage from "@/components/viedo/DatePage";
import RelateVideos from "@/components/viedo/RelateVideos";
import CommentPage from "@/components/archive/CommentPage";
import { ref } from 'vue';
import PlayList from "@/components/viedo/PlayList";

export default defineComponent({
  components: {
    PlyrPlayer,
    UpInfo,
    Share,
    DatePage,
    RelateVideos,
    CommentPage,
    PlayList
  },
  data() {
    const active = ref(0)
    return {
      active,
      Video:null,
      Category:null,
      upper:null,
      loading: true,
      vid:null,
    };
  },
  created() {
    if (!this.$route.query.pid) {
      this.$router.push({ name: 'NotFound' });
      return
    }
    this.vid = this.$route.query.pid
    // 这里判断VIP
    this.getVideoInfo()
    this.getUpperInfo()
  },
  methods:{
    async getVideoInfo() {
      this.loading = true; // 开始加载
      try {
        const res = await this.$v_http.get(`getInfo?vid=` + this.vid);
        if (res.data?.code === 0) {
          this.Video = res.data?.data?.Video;
          this.Category = res.data?.data?.Category;
        }
      } catch (error) {
        console.error('Error fetching video info:', error);
      } finally {
        this.loading = false;
      }
    },
    async getUpperInfo() {
      this.loading = true; // 开始加载
      try {
        const res = await this.$v_http.get(`upperInfo?vid=` + this.vid);
        if (res.data?.code === 0) {
          this.upper = res.data?.data;
        }
      } catch (error) {
        console.error('Error fetching upper info:', error);
      } finally {
        this.loading = false;
      }
      },
    handlePidChange() {
      if (!this.$route.query.pid) {
        this.$router.push({ name: 'NotFound' });
        return;
      }
      // 重置数据
      this.vid = this.$route.query.pid
      this.Video = null;
      this.upper = null;
      this.loading = true;
      // 重新获取数据
      this.getVideoInfo();
      this.getUpperInfo();
    },
  },

  watch: {
    '$route.query.pid'(newPid, oldPid) {
      if (newPid !== oldPid) {
        this.handlePidChange();
      }
    },
  },
  computed:{
    componentKey(){
      return this.$route.query.nid||0
    }
  }
});
</script>

<style scoped lang="scss">
.videoTabs{

  position: relative;
  &::before {
    content: "";
    position: absolute;
    z-index: 5;
    left: 0;
    top: 42px;
    width: 100%;
    height: 1px;
    background-color: #e7e7e7;
    transform: scaleY(0.5);
  }
  ::v-deep .van-tabs__line {
    background-color: #fb7a9f !important; /* Theme color */
    z-index: 50;
  }
  ::v-deep .van-tab--active {
    color: #fb7a9f !important; /* 修改选中后的文字颜色为粉色 */
    font-weight: normal !important; /* 修改选中后的文字不加粗 */
  }

  ::v-deep .van-tab {
    font-weight: normal !important; /* 确保所有tab文字默认不加粗 */
  }
  .videoTitle{
    margin:0 3vw;
    h1{
      font-size: 4vw;
      font-weight: normal;
    }
  }
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 使容器充满屏幕 */
  width: 100vw; /* 全宽 */
  position: fixed; /* 固定在页面中央 */
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8); /* 可选，添加半透明背景 */
  z-index: 9999; /* 确保在最顶层显示 */
}

</style>
